import React, {useState} from 'react';

import Header from "../../../layouts/Header";
import Navbar from "../../../layouts/Navbar";
import {useNavigate} from "react-router-dom";

import {getCalls} from "../api/OrdersAPI";
import Loading from "../../../layouts/Loading";
import {showError, showWarning} from "../../../utils/toastHelper";
import {BsTelephoneFill, BsTelephoneInbound, BsTelephoneOutbound} from "react-icons/bs";
import {BiInfoCircle} from "react-icons/bi";
import {FiPhoneMissed} from "react-icons/fi";
import {MdCall} from "react-icons/md";
import {getUserInfo} from "../../profile/api/ProfileAPIs";
import WebphoneFrame from "../../products/components/WebphoneFrame";


function Calls() {
    const navigate = useNavigate();

    const [loading, setLoading] = useState(false);
    const [calls, setCalls] = React.useState([]);
    const [theCall, setTheCall] = React.useState({phone: ''});
    const [user, setUser] = React.useState(null);
    const config = window.APP_CONFIG;

    React.useEffect(() => {


        const fetchCalls = async () => {

            try {

                const params = {
                    count: 40,
                    page: 1,
                    list: 1,
                    orderBy: 'created_at',
                    orderType: 'desc',

                }
                const data = await getCalls(params);
                setCalls(data.data[0]);

            } catch (err) {
                showError( err);
            } finally {
                setLoading(false);
            }
        };
        fetchCalls();
        setTimeout (() => {
            window.scrollTo({top: 0, behavior: 'smooth'});
        },400)

    }, []);


    React.useEffect(() => {
        const fetchUserInfo = async () => {
            try {
                const data = await getUserInfo();
                setUser(data.data.user);
            } catch (err) {
                showError(err);
            }
        };

        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if (token) {
            fetchUserInfo();
        }

    }, []);

    const getCallTypeDetails = (type) => {
        switch (type) {
            case 'income':
                return {  icon: <BsTelephoneInbound />, isMissed: false };
            case 'missed':
                return {  icon: <FiPhoneMissed />, isMissed: true };
            default:
                return {  icon: <BsTelephoneOutbound />, isMissed: false };
        }
    };



    if (loading) return <Loading />;

    return (
        <React.Fragment>

            <Header title='تماس ها' hasBack={false}/>

            <div className="modal fade" id="exampleModal" tabIndex="-1" aria-labelledby="exampleModalLabel"
                 aria-hidden="true">
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h1 className="modal-title fs-5" id="exampleModalLabel">اطلاعات تماس</h1>
                            <button type="button" className="btn-close me-5" data-bs-dismiss="modal"
                                    aria-label="Close"></button>
                        </div>
                        <div className="modal-body ios-contact-list list-group" dir='rtl'>
                            <div className="contact-item w-100 my-3"

                            >

                                <img
                                    src={theCall.avatar}
                                    alt={theCall.name}
                                    className="contact-avatar rounded-circle"
                                />


                                <div className="contact-content">


                                    <div className="user-info text-start">
                      <span className='name'>
                        {theCall.name}
                      </span>

                                    </div>

                                    {/* تاریخ و دکمه اطلاعات */}
                                    <div className="meta-info">
                                                <span
                                                    className="date text-small-2">{theCall.date}</span>

                                    </div>

                                </div>
                            </div>
                        </div>
                        <div className="modal-foote text-center p-3">
                            {theCall.phone.length > 9 ?
                                <WebphoneFrame name={theCall.name} phone={theCall.phone} btitle='تماس' webphone={user.webphone_data} />
                            :
                                <div className='text-center text-danger-emphasis'>
                                    امکان تماس وجود ندارد
                                </div>
                            }

                        </div>
                    </div>
                </div>
            </div>


            <div className="container py-4 my-4 ">
                <div className="row justify-content-center ">
                    <div className="col-md-6 col-12">

                        <div className="ios-contact-list list-group rounded mb-4 pb-3" style={{minHeight: '85vh'}}
                             dir="rtl">

                            {calls.map((call) => {
                                const {icon, isMissed} = getCallTypeDetails(call.type);

                                return (
                                    <div key={call.id} className="contact-item w-100 my-3" data-bs-toggle="modal"
                                         data-bs-target="#exampleModal"
                                         onClick={() => {

                                             const info = {
                                                 name: call.otherUser,
                                                 avatar: call.avatar,
                                                 phone: call.phone,
                                                 date: call.date,
                                             }
                                             setTheCall(info)
                                         }}
                                    >

                                        <img
                                            src={call.avatar}
                                            alt={call.otherUser}
                                            className="contact-avatar rounded-circle "
                                        />

                                        {/* محتوای اصلی */}
                                        <div className="contact-content">

                                            {/* نام و نوع تماس */}
                                            <div className="user-info text-start">
                      <span className='name'>
                        {call.otherUser}
                      </span>
                                                <span className="label-icon mt-2">
                        <strong className={isMissed ? 'missed-icon' : ''}>{icon} </strong>

                                                    {call.duration} {"  ثانیه "}
                      </span>
                                            </div>

                                            {/* تاریخ و دکمه اطلاعات */}
                                            <div className="meta-info">
                                                <span
                                                    className="date text-small-2">{call.date}</span>
                                                <span className="info-btn" role="button">
                        <MdCall/>
                      </span>
                                            </div>

                                        </div>
                                    </div>
                                );
                            })}

                        </div>
                    </div>
                </div>
            </div>


            <Navbar/>
        </React.Fragment>
    );
}

export default Calls;